import { Inbox, InboxService } from '../../inbox';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MessageService, ConfirmationService, TreeNode} from 'primeng/api';
import {Component, OnInit, Input, EventEmitter, Output, Inject, SimpleChanges} from '@angular/core';
import { FormArray, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {AlertService, AuthenticationService, ConstantService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {Msg, MsgService} from '@app/_components/msg';
import {TaskListComponent} from '@app/_components/task/task-list/task-list.component';
import {MsgTemplateService} from '@app/_components/msg-template/msg-template.service';
import {MsgRecipient} from '@app/_components/msg-recipient/msg-recipient';
import {ImapConfiguration} from '@app/_components/imap-configuration/imap-configuration';
import {MsgTemplateData} from '@app/_components/msg-template/msg-template-data';
import {PictureService} from '@app/_components/picture';
import {MsgTemplate} from '@app/_components/msg-template/msg-template';

@Component({
    selector: 'app-inbox-mail-sms',
    templateUrl: './inbox-mail-sms.component.html',
    styleUrls: ['./inbox-mail-sms.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class InboxMailSMsComponent implements OnInit {

	currentUser: User;
	currentUserSubscription: Subscription;
	selectedInbox: any;
	imapConfigId: any;
  fromTask = false;
  defaultContacts: any = [];
  toMailIdsSelected: any = [];
  ccMailIdsSelected: any = [];
  bccMailIdsSelected: any = [];
  @Input() msgTopic: any = [];
  @Input() mobilePhone: any = [];
  @Input() reservations: any = [];
  @Input() msgTopicId: any = [];
  @Input() formReadOnly = true;
  @Input() showClose = true;
  @Input() inbox: Inbox;
  @Input() msgId: any;
  @Input() msgTemplateData: MsgTemplateData;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doUpdateAndDontClose = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();
  mobileSuggestions: any[] = [];
  mobileContacts: any[] = [];        // all available mobile numbers (from reservations)
  selectedMobileContacts: any[] = []; // default selected
  msgTemplates: any;
  selectedTemplateId: any;
	countries: any;
  pictureIndex: number;
  msgContexts: any;
  msgSubContexts: any;
  msgSubContextMap: { [key: number]: any[] } = {};
  msgContextId: number | null = null;
	msgSubContextId: number | null = null;
	readonly maxAttachmentTotalSize = 20 * 1024 * 1024;
  private initialMsgSubContextId: number | null = null; // from dialog data, restored after ngOnInit
  templateMsgAudience: any;
  isTemplateLoading = false;
  senderName: any;
  senderEmail: any;
  showResponseDialog: boolean = false;
  responseDetails: any = null;
  sendViaEmail: boolean = true;
  sendViaSms: boolean = false;
	constructor(
		private primengConfig: PrimeNGConfig,
		private inboxService: InboxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private authenticationService: AuthenticationService,
		private formBuilder: UntypedFormBuilder,
    	private dialog: MatDialog,
		private dialogRef: MatDialogRef<InboxMailSMsComponent>,
    	private msgService: MsgService,
		private msgTemplateService: MsgTemplateService,
		private constantService: ConstantService,
    private pictureService: PictureService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
      this.fromTask = data.fromTask,
			this.statuses = inboxService.statuses;
			this.msgAudiences = msgService.msgAudiences;

	// For BizDev templates
	if(data.templateMsgAudience)
	{
		this.templateMsgAudience = data.templateMsgAudience;
		// If single number, convert to array
		this.selectedAudiences = Array.isArray(data.templateMsgAudience)
			? data.templateMsgAudience
			: [data.templateMsgAudience];
	}
	else
	{
		this.templateMsgAudience = null;
	}
    if ( data.msgTopicId){
	this.countries = this.constantService.countries;
      this.msgTopicId = data.msgTopicId;
    }
    if ( data.msgTopic){
      this.msgTopic = data.msgTopic;
    }
	
	if ( data.mobilePhone && data.mobilePhone != "null"){
      this.mobilePhone = data.mobilePhone;
    }
	if(data.reservations)
	{
		this.reservations = data.reservations;
	}
    if ( data.msgTemplateData){
      this.msgTemplateData = data.msgTemplateData;
	}
	if( data.msgContextId)
	{
		this.msgContextId = data.msgContextId;
	}
	if (data.msgSubContextId != null && data.msgSubContextId !== '') {
		this.msgSubContextId = data.msgSubContextId;
		this.initialMsgSubContextId = data.msgSubContextId;
	}
	if (data.msgTemplateId) {
		this.selectedTemplateId = data.msgTemplateId;
	}
	if (data.initialAttachments && Array.isArray(data.initialAttachments) && data.initialAttachments.length > 0) {
		this.uploadedFiles = [...data.initialAttachments];
	}
	if (data.ownerEmails && Array.isArray(data.ownerEmails) && data.ownerEmails.length > 0) {
		this.ownerEmails = data.ownerEmails;
	} else {
		this.ownerEmails = [];
	}
	if (data.stripVars && Array.isArray(data.stripVars) && data.stripVars.length > 0) {
		this.stripVars = data.stripVars;
	}
		if (data.sendViaEmail !== undefined) {
			this.sendViaEmail = data.sendViaEmail;
		}
		if (data.sendViaSms !== undefined) {
			this.sendViaSms = data.sendViaSms;
		}
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
		this.defaultContacts = [];
	}
	// data
	inboxId: number;
	selectedMsgRecipients: any[] = [];
	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	isSendEnable: boolean;
	isReplyEnable: boolean;
	statuses: any;
	msgAudiences: any;
	selectedAudiences: number[] = [];

	validationMessages = {
		'inboxId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
    'subject': [],
		'status': [],
		'inboxDate': [],
		'isInbox': [],
		'mobileNum': [],
		'mobileCountryCode': [],
		'inboxNames': [{ type: 'required', message: 'Required' }]
	};
  uploadedFiles: any[] = [];
  ownerEmails: any = [];
  stripVars: string[] = [];

	ngOnInit() {
		this.countries = this.constantService.countries;
		this.msgContexts = this.inboxService.msgContexts;
		this.msgSubContextMap = this.inboxService.msgSubContextMap;
		this.primengConfig.ripple = true;
		this.formBuild();
		if (this.inbox && this.inbox.senderEmail) {
			this.defaultContacts.push({emailAddress: this.inbox.senderEmail});
		}
		// if we were passed the whole inbox object
		if (this.inbox && this.inbox?.msgId) {
			this.isSendEnable = false;
			this.isReplyEnable = true;
			this.inboxId = this.inbox.msgId;
			this.fixDates();
			const inboxData = { ...this.inbox };
			if (inboxData.emailHtml) {
				inboxData.emailHtml = this.cleanHtmlForEditor(this.decodeHtmlForPayload(inboxData.emailHtml));
			}
			this.form1.patchValue(inboxData);
			this.imapConfigId = this.form1.value.imapConfigId;
		} else {
			this.isSendEnable = true;
			this.formReadOnly = false;
		}
		if (this.inbox && !this.inbox?.msgId) {
			const inboxData = { ...this.inbox };
			if (inboxData.emailHtml) {
				inboxData.emailHtml = this.cleanHtmlForEditor(this.decodeHtmlForPayload(inboxData.emailHtml));
			}
			this.form1.patchValue(inboxData);
		}
		
		if (this.reservations && this.reservations.length > 0) {
			const uniqueEmails = new Set<string>();
			for (const res of this.reservations) {
				const email = res?.emailAddress?.trim() || res?.guestProfile?.emailAddress?.trim();
				if (email) {
					uniqueEmails.add(email);
				}
		}
		// Convert to array of { emailAddress: string }
    	this.toMailIdsSelected = Array.from(uniqueEmails).map(email => ({ emailAddress: email }));
		this.defaultContacts = [...this.toMailIdsSelected];
		// Also patch form "toEmails" field so it's visible in UI
		this.form1.patchValue({
			toEmails: Array.from(uniqueEmails).join(', ')
		});
		const uniqueMobiles = new Set<string>();
		for (const res of this.reservations) {
			let phone = res?.primaryMobilePhone?.trim();
			if (!phone && res?.guestProfile?.mobilePhone?.trim() != "") {
				phone = res.guestProfile.mobilePhone.trim();
			}
			if (phone && phone != "null") uniqueMobiles.add(phone);
		}

		this.mobileContacts = Array.from(uniqueMobiles).map(num => ({ mobileNum: num }));
		this.selectedMobileContacts = [...this.mobileContacts];

		// Patch into form so they appear preselected
		// this.form1.patchValue({
		// 	mobileNum: this.selectedMobileContacts
		// });

		console.log('Auto-populated mobile numbers:', this.selectedMobileContacts);
	}

		// Prefill To and mobile from owner emails (e.g. from owner statement mail)
		if (this.ownerEmails && this.ownerEmails.length > 0) {
			const emails = this.ownerEmails.map(o => ({ emailAddress: o.email?.trim(), firstName: o.firstName, lastName: o.lastName })).filter(Boolean);
			if (emails.length > 0) {
				this.toMailIdsSelected = emails;
				this.defaultContacts = [...this.toMailIdsSelected];
				this.form1.patchValue({ toEmails: emails.join(', ') });
			}
		}

    if ( this.msgTemplateData ){
      this.defaultContacts.push({emailAddress: this.msgTemplateData.emailAddress});
      this.form1.patchValue({ toEmails: this.msgTemplateData.emailAddress, mobileCountryCode: '+1', mobileNum: this.mobilePhone});
		// this.form1.patchValue({ toEmails: this.msgTemplateData.emailAddress, mobileCountryCode: '+1'});
    }
	this.form1.patchValue({ mobileCountryCode: '+1', mobileNum: this.mobilePhone});
	// this.form1.patchValue({ mobileCountryCode: '+1'});

		if(this.msgTopic && this.msgTopic.includes(100))
		{
			this.msgContextId = 7;
		}
		this.fetchAllTemplates(this.selectedAudiences);

		// Initialize subcontexts if context is already selected
		if (this.msgContextId) {
			this.onMsgContextChange(this.msgContextId);
			// Restore msgSubContextId when it was passed via dialog data (e.g. owner statement mail)
			if (this.initialMsgSubContextId != null) {
				this.msgSubContextId = this.initialMsgSubContextId;
			}
		}
		if (this.selectedTemplateId) {
			this.form1.patchValue({ msgTemplateId: this.selectedTemplateId });
			this.selectTemplate({ value: this.selectedTemplateId }, 0);
		}
	}

	onMsgContextChange(contextId: number) {
		this.msgSubContexts = this.msgSubContextMap[contextId] || [];
		this.msgSubContextId = null; // Reset selected subcontext
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.inbox.createDate = moment(this.inbox.createDate).toDate();
	}

	replyMail() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.isSendEnable = true;
			this.isReplyEnable = false;
      this.formReadOnly = false;
			this.form1.get('imapConfigId').setValue(String(this.imapConfigId));
			const emailHtml = '<div dir="ltr" gmail_original="1"><br><br><br></div><div class="gmail_quote"><div dir="ltr" class="gmail_attr">On ' + this.form1.value.receivedDate + ' ' + this.form1.value.senderName + ' &lt;<a href="mailto:' + this.form1.value.senderEmail + '">' + this.form1.value.senderEmail + '</a>&gt; wrote:<br></div>' +
				'<blockquote class="gmail_quote" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><div dir="ltr"><br></div><br>' + this.form1.value.emailHtml;
			const toEmail = this.form1.value.senderEmail;
			this.defaultContacts = [];
      this.defaultContacts.push(toEmail);
      let replyPrefix = (this.form1.value.subject && this.form1.value.subject.startsWith('Re: ')) ? '' : 'Re: ';
			this.form1.patchValue({ emailHtml: emailHtml, toEmails: toEmail, subject: replyPrefix + this.form1.value.subject,
        parentMsgId: this.form1.value.msgId});

		} catch (error) {
			this.alertService.error(error);
		}
	}
	getAudienceName(value: any): string {
		const found = this.msgAudiences.find(a => a.value === value);
		return found ? found.name : value;
	}

	async sendMail() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			const emailRecipients: MsgRecipient[] = [];
			if (this.toMailIdsSelected && this.toMailIdsSelected.length > 0 ){
				for (let mail of this.toMailIdsSelected) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'To';
					emailRecipients.push(msgRecipient);
				}
				emailRecipients[0].mobileNum = this.form1.value.mobileNum != null ? String(this.form1.value.mobileNum).trim() : '';
				emailRecipients[0].mobileCountryCode = this.form1.value.mobileCountryCode;
			}
			else{
        if ( this.form1.value.mobileNum){
          const msgRecipient = new MsgRecipient();
          msgRecipient.mobileNum = String(this.form1.value.mobileNum).trim();
          msgRecipient.mobileCountryCode = this.form1.value.mobileCountryCode;
          emailRecipients.push(msgRecipient);
        }
			}
			
			//Remove below comment and comment above else part when back-end is ready to accept multiple mobile numbers
			// if (this.form1.value.mobileNum && this.form1.value.mobileNum.length > 0 ){
			// 	for (let mobile of this.form1.value.mobileNum) {
			// 		const msgRecipient = new MsgRecipient();
			// 		msgRecipient.mobileNum = mobile.mobileNum;
			// 		msgRecipient.mobileCountryCode = this.form1.value.mobileCountryCode;
			// 		emailRecipients.push(msgRecipient);
			// 	}
			// }
			if (this.ccMailIdsSelected && this.ccMailIdsSelected.length > 0 ){
				for (const mail of this.ccMailIdsSelected) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'Cc';
					emailRecipients.push(msgRecipient);
				}
			}
			if (this.bccMailIdsSelected && this.bccMailIdsSelected.length > 0 ){
				for (const mail of this.bccMailIdsSelected) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'Bcc';
					emailRecipients.push(msgRecipient);
				}
			}
			let mailSet = new Set();
			for (const receipient of emailRecipients){
				let mail = receipient.email;
				if(mail)
				{
					if (mailSet.has(mail)){
						this.alertService.error('To , Cc and Bcc should have unique mail Ids.');
						return;
					}
					else{
						mailSet.add(mail);
					}
				}
			}

			// At least one recipient must exist
			if (emailRecipients.length === 0) {
				this.alertService.error('Please add at least one recipient (To, Cc, Bcc or Mobile).');
				return;
			}

		const mediums: string[] = [];
		for (const recipient of emailRecipients) {
			if (!recipient) continue;
			if (recipient.email && this.sendViaEmail && !mediums.includes('EMAIL')) {
				mediums.push('EMAIL');
			}
			if (recipient.mobileNum && this.sendViaSms && this.isValid(this.form1.value.mobileText) 
				&& !mediums.includes('SMS')) {
				mediums.push('SMS');
			}
			if (mediums.length === 2) break;
		}
	const emailAttachments = await this.buildEmailAttachments();
	let msgRequest: any = {
		msgRecipients: emailRecipients,
		mediums: mediums,
		emailHtml: this.decodeHtmlForPayload(this.form1.value.emailHtml),
		mobileText: this.form1.value.mobileText,
		subject: this.form1.value.subject,
		msgOrigin: 1,
		msgRole: 4,
		templateId: this.selectedTemplateId,
		msgContext: this.msgContextId ? this.msgContextId : null,
		msgSubContext: this.msgSubContextId ? this.msgSubContextId : null,
		senderName: this.senderName,
		senderEmail: this.senderEmail,
		emailAttachments: emailAttachments.length > 0 ? emailAttachments : [],
		smsAttachments: emailAttachments.length > 0 ? emailAttachments : []
	};
	if (this.msgTopic && this.msgTopic.includes(100))
	{
		// find the index of topic 100
		const index = this.msgTopic.indexOf(100);

		// set reservationId from the corresponding msgTopicId
		if (index !== -1) {
			msgRequest.reservationId = this.msgTopicId[index];
		}
	}
	if (this.msgTopic && this.msgTopic.includes(2600)) {
		const index = this.msgTopic.indexOf(2600);
		if (index !== -1 && this.msgTopicId && this.msgTopicId[index] != null) {
			msgRequest.topic = 2600;
			msgRequest.topicId = this.msgTopicId[index];
		}
	}
	if(this.selectedTemplateId && this.form1.value.reservationForms?.length > 0)
	{
		const reservationForms = this.form1.value.reservationForms;
		let requestList = [];
		const msgRequestsList = reservationForms.map((reservationForm: any) => {
			const msgRecipients: MsgRecipient[] = [];
			const mediums: string[] = [];
			// Create msgRecipients for toMailIds (multiple emails possible)
			if (reservationForm.toMailIds && this.sendViaEmail && reservationForm.toMailIds.length > 0) {
				for (const mail of reservationForm.toMailIds) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'To';
					msgRecipients.push(msgRecipient);
				}
				mediums.push('EMAIL');
			}

			// Create msgRecipients for mobileNum (multiple numbers possible)
			// if (reservationForm.mobileNum && reservationForm.mobileNum.length > 0) {
			if (reservationForm.mobileNum) {
					msgRecipients[0].mobileNum = reservationForm.mobileNum != null ? String(reservationForm.mobileNum).trim() : '';
					msgRecipients[0].mobileCountryCode = reservationForm.mobileCountryCode;
				// }
				if(this.sendViaSms && this.isValid(reservationForm.mobileText))
				{
					mediums.push('SMS');
				}
			}

			// Create a new msgRequest for each reservationForm, copying existing values
			let copiedMsgRequest = { ...msgRequest };

			// Prepare msgRequest for this reservationForm
				copiedMsgRequest['msgRecipients'] = msgRecipients;
				copiedMsgRequest['mediums'] = mediums;
				copiedMsgRequest['emailHtml'] = this.decodeHtmlForPayload(reservationForm.emailHtml);
				copiedMsgRequest['mobileText'] = reservationForm.mobileText;
				copiedMsgRequest['subject'] = reservationForm.subject;
				copiedMsgRequest['templateId'] = reservationForm.msgTemplateId;
				copiedMsgRequest['reservationId'] = reservationForm.reservationId;
				copiedMsgRequest['emailAttachments'] = emailAttachments.length > 0 ? emailAttachments : [];
				copiedMsgRequest['smsAttachments'] = this.sendViaSms ? (emailAttachments.length > 0 ? emailAttachments : []) : [];

				requestList.push(copiedMsgRequest);
            });

			console.log(requestList);

			this.formLoading = true;
			this.msgService.sendMsgPerReservation(requestList).subscribe(
			(res: any) => {
					console.log('send message, SUCCESS: ', res?.msgResponse?.msges?.[0]);
				this.responseDetails = {
					recipients: res?.data?.msgResponse?.msges?.[0]?.msgRecipientAPIList || [this.form1.value.mobileNum],
					status: 'Success',
					errors: res?.errors,
					message: res?.message || 'Mail sent successfully'
				};
				this.messageService.add({
					severity: 'success',
					summary: 'Success',
					detail: this.responseDetails.message
				});
				this.formLoading = false;
				this.inbox = res.data.msg;
				// this.doUpdate.emit(this.inbox);
				// Delay close so the toast can render before the dialog (and its p-toast) is destroyed
				setTimeout(() => {
					this.dialogRef.close();
					this.doUpdate.emit(this.inbox);
				}, 1000);
			},
			(err: any) => {
				// Do NOT reset formLoading on error — a 504 means the message may have been sent.
				// Keep button disabled to prevent a duplicate message from being triggered.
				console.log('msg-add FAIL: ' + JSON.stringify(err));
				// this.alertService.error(err);
				this.responseDetails = {
					recipients: this.form1.value.to,
					status: 'Failed',
					errors: err?.errors,
					message: err?.message || 'Failed to send mail/SMS. Please refresh before retrying.'
				};
				let errorMessage = "";
				if (err?.errors && err?.errors.length > 0) {
					for (let i = 0; i < err?.errors.length; i++) {
						errorMessage += err?.errors[i]?.message + ', ';
					}
					errorMessage = errorMessage.slice(0, -2);
				}
				else{
					errorMessage = err?.message || 'Failed to send. Please refresh before retrying.';
				}
				this.messageService.add({
					severity: 'error',
					summary: 'Failed',
					detail: errorMessage
				});
			},
			() => {
			}
		);
	}
	else
	{
		msgRequest.emailHtml = this.decodeHtmlForPayload(msgRequest.emailHtml);
		this.formLoading = true;
		this.msgService.sendMsg(msgRequest).subscribe(
			(res: any) => {
				console.log('send message, SUCCESS: ', res, res?.errors);
				this.responseDetails = {
					recipients: res?.data?.msgResponse?.msges?.[0]?.msgRecipientAPIList || [this.form1.value.mobileNum],
					status: 'Success',
					message: res?.message || 'Mail sent successfully',
					errors: res?.errors,
				};
				this.messageService.add({
					severity: 'success',
					summary: 'Success',
					detail: this.responseDetails.message
				});
				this.formLoading = false;
				this.inbox = res.data.msg;
				// this.doUpdate.emit(this.inbox);
				// Delay close so the toast can render before the dialog (and its p-toast) is destroyed
				setTimeout(() =>{ 
					this.dialogRef.close();
					this.doUpdate.emit(this.inbox);
				}, 1000);
			},
			(err: any) => {
				// Do NOT reset formLoading on error — a 504 means the message may have been sent.
				// Keep button disabled to prevent a duplicate message from being triggered.
				console.log('msg-add FAIL: ', err);
				// this.alertService.error(err);
				this.responseDetails = {
					recipients: this.form1.value.to,
					status: 'Failed',
					message: err?.message || 'Failed to send mail/SMS. Please refresh before retrying.',
					errors: err?.errors,
				};
				let errorMessage = "";
				if (err?.errors && err?.errors.length > 0) {
					for (let i = 0; i < err?.errors.length; i++) {
						errorMessage += err?.errors[i]?.message + ', ';
					}
					errorMessage = errorMessage.slice(0, -2);
				}
				else{
					errorMessage = err?.message || 'Failed to send mail/SMS';
				}
				this.messageService.add({
					severity: 'error',
					summary: 'Failed',
					detail: errorMessage
				});
			},
			() => {
			}
		);
	}
		} catch (error) {
			this.formLoading = false;
			this.alertService.error(error);
		}
	}
	onDialogOk() {
		this.showResponseDialog = false;
		this.doUpdate.emit(this.inbox);
		this.messageService.add({severity: 'info', summary: 'Done', detail: 'You can send another message.'});
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			msgId: [],
			sentDate: [],
			receivedDate: [],
			senderName: [],
			senderEmail: [],
			subject: [],
			senderMobileNum: ['8084009160'],
			senderCountryCode: ['+1'],
			mobileNum: [],
			mobileCountryCode: [],
			preHeader: [],
			emailHtml: [],
			replyEmailHtml: [],
			emailText: [],
			mobileText: [],
			headers: [],
			status: [],
			statusMsg: [],
			confId: [],
			trackingId: [],
			opsNotes: [],
			campaignVars: [],
			msgRecipientAPIList: [],
			msgTemplateId:[],
			topic: [],
			topicId: [],
			toEmails: [],
			ccEmails: [],
			bccEmails: [],
			imapConfigId: [],
			reservationForms: this.formBuilder.array([])
		});
	}

  openCreateTask(selectedNode: Inbox) {
    const dialogConfig = new MatDialogConfig();

	  // settings
	  dialogConfig.width = '100vw';
	  dialogConfig.height = '100vh';
	  dialogConfig.maxWidth = '100vw';
	  dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    let sel = selectedNode as object;
    // pass data, ie rateBuicket: this.shortTermRentalId,
	  let custTaskApi = {name: selectedNode.subject};
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
      purpose: 'createmailtask',
	 taskApi: custTaskApi,
      msg: sel as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        let taskAPI = {
          taskId: undefined
        };
        // @ts-ignore
        msg.msgId = sel?.msgId;
        taskAPI.taskId = data.taskId;
        msg.taskAPI = taskAPI;
        try {
          this.msgService.findById(msg.msgId).subscribe(
            (res: any) => {
              console.log('property-update SUCCESS: ' + JSON.stringify(res));
				this.inbox = res?.data?.msg;
				this.doUpdateAndDontClose.emit(this.inbox);
              this.messageService.add({
                severity: 'success',
                summary: 'Task Created',
                detail: res.message,
              });
            },
            (err: any) => {
              console.log('property-update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => {
            }
          );
        } catch (error) {
          console.log('Form Invalid: ' + JSON.stringify(error));
          this.alertService.error(error);
        }
        dialogRef.close();
      });
  }

  archiveMsg(selectedNode: Inbox) {
    try {
      let msg  =  new Msg();
      let sel = selectedNode as object;
      // @ts-ignore
      msg.msgId = sel?.msgId;
      msg.msgFolder = 2;  // 2 is for archive folder
      this.msgService.archiveMsg(msg).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Archived',
            detail: res.message,
          });
          this.doUpdateAndDontClose.emit(this.inbox);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
        }
      );
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
  toMailSelected($event: any) {
    this.toMailIdsSelected = $event;
  }
  ccMailSelected($event: any) {
    this.ccMailIdsSelected = $event;
  }
  bccMailSelected($event: any) {
    this.bccMailIdsSelected = $event;
  }

  private getStrToEMails(mailAraay) {
    let mails = '';
    if ( !mailAraay || mailAraay?.length === 0 ){
      return null;
    }
    mails = mailAraay[0]?.emailAddress;
    for ( let i = 1; i < mailAraay?.length; i++){
      if ( mailAraay[i]?.emailAddress){
        mails = mails + ',' + mailAraay[i]?.emailAddress;
      }
    }
    return mails;
  }
	openViewTask(rowData: any) {
		if (rowData.taskAPIList?.length > 1) {
			const dialogConfig = new MatDialogConfig();
			// settings
			dialogConfig.width = '100%';
			dialogConfig.height = '100%';
			dialogConfig.maxWidth = '1600px';
			dialogConfig.maxHeight = '800px';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				title: 'Mail Tasks',
				isModal: true,
				parentMsgId: rowData.msgId,
				fromMail: true,
				showFilter: false,
				showPagination: false,
				outlineNewButton: false,
			};
			const dialogRef = this.dialog.open(TaskListComponent, dialogConfig);
		} else {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.width = '100vw';
			dialogConfig.height = '100vh';
			dialogConfig.maxWidth = '100vw';
			dialogConfig.maxHeight = '100vh';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.data = {
				title: 'Assign Task',
				isModal: true,
				taskApi: rowData?.taskAPIList[0],
				fromMail: false
			};

			const dialogRef = this.dialog.open(TaskComponent, dialogConfig);
			dialogRef.componentInstance.doAdd.subscribe(
				data => {
					console.log('Dialog output:', data);
					dialogRef.close();
				});
		}
	}
	fetchAllTemplates(selectedAudiences) {
		// if (!this.msgTemplates || this.msgTemplates === undefined || this.msgTemplates.length < 1) {
			try {
        let msgTemplate = new MsgTemplate();
		if(selectedAudiences)
		{
			msgTemplate.msgAudience = selectedAudiences;
		}
        msgTemplate.status = 1;
				this.msgTemplateService.findAllForDropDown(msgTemplate)
					.subscribe(
						res => {
							console.log('employee Profiles: ' + JSON.stringify(res));
							this.msgTemplates = res.data.msgTemplates;
							this.msgTemplates.sort((a, b) => {
								const audienceA = this.getAudienceName(a.msgAudience)?.toLowerCase() || 'zzz';
								const audienceB = this.getAudienceName(b.msgAudience)?.toLowerCase() || 'zzz';

								if (audienceA !== audienceB) {
									return audienceA.localeCompare(audienceB);
								}

								return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
							});
							return this.msgTemplates;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		// }
		// else {
		// 	return (this.msgTemplates);
		// }
	}
	selectTemplate(event, resIndex: number) {
		const selectedId = event?.value;
		// nothing selected/cleared
		if (selectedId === null || selectedId === undefined || selectedId === '') {
			this.selectedTemplateId = null;
			this.form1.patchValue({ msgTemplateId: null });
			return;
		}
  		this.selectedTemplateId = selectedId;
		this.isTemplateLoading = true; // show overlay
   
   if (this.msgTopicId && this.msgTopic && this.msgTopic.length > 0 && this.msgTopic[0] != undefined) {
		this.formLoading = true;
		const body = {
			msgTemplateId: selectedId,
			topics: this.msgTopic.map((topic: number, index: number) => ({
				topic: topic,
				topicId: this.msgTopicId[index]
			}))
		};
		this.msgTemplateService.mergeTemplateBatch(body).subscribe(
		  (res: any) => {
			let msgTemplateLocal = res?.data?.msg;
			this.senderName = msgTemplateLocal?.senderName || null;
			this.senderEmail = msgTemplateLocal?.senderEmail || null;

			let mailText = this.applyStripVars(msgTemplateLocal.emailHtml);
			let subject = msgTemplateLocal.subject;
				let smsText = this.applyStripVars(msgTemplateLocal.mobileText);

				const cleanedMailText = this.cleanHtmlForEditor(this.decodeHtmlForPayload(mailText));
			this.form1.patchValue({
			  emailHtml: cleanedMailText,
			  mobileText: smsText,
			  subject: subject,
			});
			if( msgTemplateLocal?.opsNotes){
			  this.alertService.error(msgTemplateLocal.opsNotes);
			}
			if(!this.form1.value.reservationForms || this.form1.value.reservationForms.length == 0)
			{
				this.initReservationForms();
			}
			else
			{
				const resForm = this.reservationForms.at(resIndex);
				resForm.patchValue({
					emailHtml: cleanedMailText,
					mobileText: smsText,
					subject: subject,
					msgTemplateId: selectedId
				});
			}
		  },
		  (err: any) => {
			console.log('msgTemplate-add FAIL: ' + JSON.stringify(err));
			this.alertService.error(err);
			this.formLoading = false;
			this.isTemplateLoading = false;
		  },
		  () => {
			this.formLoading = false;
			this.isTemplateLoading = false;
		  }
		);
	}
  else
  {
	try {
		this.isTemplateLoading = true;
		this.msgTemplateService.findById(selectedId)
		.subscribe(
		res => {
			const tpl = res.data?.msgTemplate;
			this.senderName = tpl?.senderName || null;
			this.senderEmail = tpl?.senderEmail || null;
			const cleanedEmailHtml = this.cleanHtmlForEditor(this.decodeHtmlForPayload(this.applyStripVars(tpl.emailHtml)));
			this.form1.patchValue({
				subject: tpl.subject,
				emailHtml: cleanedEmailHtml,
				emailText: tpl.emailText,
				msgTemplateId: selectedId,
				mobileText: this.applyStripVars(tpl.mobileText),
			});
			if(!this.form1.value.reservationForms || this.form1.value.reservationForms.length == 0)
			{
				this.initReservationForms();
			}
		},
		err => {
			this.alertService.error(err);
			this.isTemplateLoading = false;
		},
		() => {
			this.isTemplateLoading = false;
		});
	} catch (error) {
		this.isTemplateLoading = false;
		console.log('Form Invalid: ' + JSON.stringify(error));
		this.alertService.error(error);
	}
  }

	}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input?.files;
    if (!files || files.length === 0) return;
    const newFiles = Array.from(files);
    const currentTotal = this.uploadedFiles.reduce((sum, f) => sum + (f.size || 0), 0);
    let runningTotal = currentTotal;
    const toAdd: File[] = [];
    let limitReached = false;
    for (const file of newFiles) {
      if (runningTotal + file.size > this.maxAttachmentTotalSize) {
        limitReached = true;
        break;
      }
      toAdd.push(file);
      runningTotal += file.size;
    }
    this.uploadedFiles = [...this.uploadedFiles, ...toAdd];
    if (limitReached || (toAdd.length < newFiles.length && runningTotal >= this.maxAttachmentTotalSize)) {
      this.messageService.add({ severity: 'info', summary: 'Limit reached', detail: 'Total attachments cannot exceed 20MB.', life: 3000 });
    }
    input.value = '';
  }

  myUploader(event: any) {
    if (event?.currentFiles) {
      this.uploadedFiles = event.currentFiles;
    }
  }

  removeAttachment(index: number): void {
    if (index >= 0 && index < this.uploadedFiles.length) {
      this.uploadedFiles = this.uploadedFiles.slice(0, index).concat(this.uploadedFiles.slice(index + 1));
    }
  }

  viewAttachment(file: File): void {
    try {
      const url = URL.createObjectURL(file);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      console.error('Could not open file for preview:', e);
      this.alertService?.error('Unable to preview this file.');
    }
  }

  isPdf(file: File): boolean {
    return file?.type === 'application/pdf';
  }

  formatFileSize(bytes: number): string {
    if (bytes == null || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  private fileToBase64Attachment(file: File): Promise<{ content: string; filename: string; type: string }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result as string;
        const base64 = dataUrl && dataUrl.indexOf('base64,') >= 0 ? dataUrl.split('base64,')[1] : dataUrl;
        resolve({
          content: base64 || '',
          filename: file.name || 'attachment',
          type: file.type || 'application/octet-stream'
        });
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }


  private applyStripVars(html: string): string {
    if (!html || this.stripVars.length === 0) return html;
    let result = html;
    this.stripVars.forEach(v => result = result.split(v).join(''));
    return result;
  }

  private decodeHtmlForPayload(html: string | null | undefined): string {
    if (html == null || html === '') {
      return html ?? '';
    }
    const textarea = document.createElement('textarea');
	  textarea.innerHTML = html;
	  console.log('textarea.value', textarea.value);
    return textarea.value;
  }

	private cleanHtmlForEditor(html: string | null | undefined): string {
		if (!html) return '';
		let cleaned = html;
		cleaned = cleaned.replace(/<strong[^>]*>\s*<\/strong>/gi, '');
		let previousLength = 0;
		while (previousLength !== cleaned.length) {
			previousLength = cleaned.length;
			cleaned = cleaned.replace(/<p[^>]*>\s*<\/p>/gi, '');
			cleaned = cleaned.replace(/<p[^>]*>\s*(<[^>]+>\s*<\/[^>]+>\s*)*<\/p>/gi, '');
		}
		previousLength = 0;
		while (previousLength !== cleaned.length) {
			previousLength = cleaned.length;
			cleaned = cleaned.replace(/<\/p>\s*<br\s*\/?>\s*<p/gi, '</p><p');
			cleaned = cleaned.replace(/<br\s*\/?>\s*(?=<p)/gi, '');
		}
		cleaned = cleaned.replace(/(<br\s*\/?>\s*){3,}/gi, '<br><br>');
		cleaned = cleaned.replace(/<p([^>]*)>\s*<br\s*\/?>/gi, '<p$1>');
		cleaned = cleaned.replace(/<br\s*\/?>\s*<\/p>/gi, '</p>');
		cleaned = cleaned.replace(/<\/p>\s*<\/p>/gi, '</p>');
		cleaned = cleaned.replace(/(<\/p>)(\s*<br\s*\/?>\s*)+$/gi, '$1');
		cleaned = cleaned.replace(/([^>])(\s*<br\s*\/?>\s*)+$/gi, '$1');
		cleaned = cleaned.replace(/(<\/p>)(\s*<p[^>]*>\s*<\/p>\s*)+$/gi, '$1');
		cleaned = cleaned.replace(/(<\/p>)(\s*\n\s*<p[^>]*>\s*<\/p>\s*)+$/gi, '$1');
		cleaned = cleaned.replace(/(<\/p>)(\s*\n\s*)+$/gi, '$1');
		cleaned = cleaned.replace(/\n\s*$/g, '');
		cleaned = cleaned.replace(/\s+$/g, '');
		cleaned = cleaned.replace(/>\s+</g, '><');
		cleaned = cleaned.replace(/>\s{2,}/g, '> ');
		cleaned = cleaned.replace(/\s{2,}</g, ' <');
		
		return cleaned.trim();
	}


  private buildEmailAttachments(): Promise<Array<{ content: string; filename: string; type: string }>> {
    if (!this.uploadedFiles || this.uploadedFiles.length === 0) {
      return Promise.resolve([]);
    }
    const files = this.uploadedFiles.filter(f => f instanceof File) as File[];
    if (files.length === 0) return Promise.resolve([]);
    return Promise.all(files.map(f => this.fileToBase64Attachment(f)));
  }

onMobileKeyInput(event) {
  const query = event.query?.toLowerCase();
  this.mobileSuggestions = this.mobileContacts.filter(c =>
    c.mobileNum.toLowerCase().includes(query)
  );
}

onMobileKeyUp(event: KeyboardEvent) {
  if (event.key === 'Enter' || event.key === ',' || event.key === ' ') {
    const tokenInput = event.srcElement as any;
    if (tokenInput.value) {
      const value = tokenInput.value.replace(/[,\s]/g, '');
      if (this.validPhone(value)) {
        const newMobile = { mobileNum: value };
        this.form1.value.mobileNum.push(newMobile);
        this.form1.patchValue({ mobileNum: this.form1.value.mobileNum });
      }
      tokenInput.value = '';
    }
  }
}

onMobileSelect(event) {
  console.log('Mobile selected:', event);
}

onMobileUnselect(event) {
  console.log('Mobile unselected:', event);
}

onMobileFocusGone(event) {
  const tokenInput = event.srcElement as any;
  if (tokenInput.value) {
    const value = tokenInput.value.replace(/[,\s]/g, '');
    if (this.validPhone(value)) {
      this.form1.value.mobileNum.push({ mobileNum: value });
      this.form1.patchValue({ mobileNum: this.form1.value.mobileNum });
    }
    tokenInput.value = '';
  }
}

validPhone(num: string) {
  return /^\+?[0-9]{7,15}$/.test(num);
}

get reservationForms(): UntypedFormArray {
  return this.form1.get('reservationForms') as UntypedFormArray;
}

	// Called after reservations are loaded
	initReservationForms() {
		const resArray = this.form1.get('reservationForms') as FormArray;
		this.reservations.forEach(res => {
			//Remove below comment for mobile when back-end is ready to accept multiple mobile numbers
			const email = res.guestProfile?.emailAddress || null;
			const mobile = this.isValid(res.primaryMobilePhone) ? res.primaryMobilePhone : this.isValid(res.guestProfile?.mobilePhone) ? res.guestProfile?.mobilePhone : null;
			resArray.push(this.formBuilder.group({
				toMailIds: email ? [[{emailAddress: email}]] : [[]],
				// mobileNum: mobile ? [[{ mobileNum: mobile}]] : [[]],
				mobileNum: mobile,
				msgTemplateId: [this.selectedTemplateId || null],
				guestName: [res.guestName || ''],
				subject: [this.form1.get('subject').value || ''],
				emailHtml: [this.decodeHtmlForPayload(this.form1.value.emailHtml) || ''],
				emailText: [this.form1.value.emailText || ''],
				mobileCountryCode: ['+1'],
				mobileText: [this.form1.value.mobileText || ''],
				files: [[]],
				reservationId: [res.reservationId]
			}));
		});
	}

	isValid(value: any): boolean {
		return value !== null && value !== undefined && value !== '' && value !== 'null';
	}
	onAudienceChange(value:any)
	{
		this.fetchAllTemplates(value);
	}
}
